export default function slugify(name = '') {
    return name
        .replace(/&/g, '-and-')
        .replace(/\s+\+\s+/g, '-plus-')
        .replace(/\+/g, 'plus')
        .replace(/[^\w\d]/gi, ' ')
        .trim()
        .replace(/\s+/g, '-');
}

export const unslugify = (slug = '') =>
    slug
        .replace(/-and-/g, '-&-')
        .replace(/-plus-/g, '-+-')
        .replace(/-/g, ' ')
        .trim();
